import styled from '@emotion/styled';

/**
 * ConsumerBackButton — bouton retour rond avec 2 variants (light / dark).
 *
 * NOTE : Un BackButton global pourra absorber ce composant dans un commit
 * de polish en ajoutant un prop `variant: 'light' | 'dark'`.
 */

export default function ConsumerBackButton({ onBack, label, variant = 'light', ariaLabel }) {
  const dark = variant === 'dark';
  return (
    <Row>
      <Circle
        type="button"
        onClick={onBack}
        $dark={dark}
        aria-label={ariaLabel || label || 'Retour'}
      >
        <Chevron aria-hidden="true" width="18" height="18" viewBox="0 0 24 24"
          fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 18l-6-6 6-6" />
        </Chevron>
      </Circle>
      {label && <Label $dark={dark}>{label}</Label>}
    </Row>
  );
}

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 0 10px;
`;

const Circle = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${p => p.$dark ? 'rgba(255,255,255,0.1)' : p.theme.palette.background.paper};
  border: 1px solid ${p => p.$dark ? 'rgba(255,255,255,0.15)' : p.theme.palette.border.main};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${p => p.$dark ? 'none' : p.theme.shadows[1]};
  flex-shrink: 0;
  padding: 0;
  color: ${p => p.$dark ? '#fff' : p.theme.palette.text.secondary};
  &:focus-visible {
    outline: 2px solid ${p => p.theme.palette.accent.main};
    outline-offset: 2px;
  }
`;

const Chevron = styled.svg``;

const Label = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: ${p => p.$dark ? '#fff' : p.theme.palette.text.primary};
  letter-spacing: -0.3px;
  font-family: ${p => p.theme.typography.fontFamily};
`;
